// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-G":"G_solar-60w-G__e6S48"};